import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.pt.mdx';

export const title = 'Número de vendas por campanha (Gráfico)';

Gráfico da quantidade de vendas atribuídas a campanhas.

<CampaignAttributionDateNote />
